import { useEffect, useState } from 'react';
import {obtenerUsuariosTerapeutasOcupacionales,
    obtenerUsuariosPsicologas,obtenerUsuariosOtros,obtenerParticipacionGrupalPorId, editarParticipacionGrupal} from '../data/FichaConsultante';
import { useContext } from "react";
import { AuthContext } from "auth";
import moment from 'moment';
import 'moment/locale/es';



export const useFichaParticipacionGrupal= (ParticipacionGrupalId) => {
    var {user}= useContext(AuthContext)
  
    const [participacionFicha,setParticipacionFicha]=useState({participacionGrupalId:ParticipacionGrupalId});
    const [usuariosTo,setUsuariosTo]=useState();
    const [usuariosSicologas,setUsuariosSicologas]=useState();
    const [usuariosOtros,setUsuariosOtros]=useState();
    const [respuestaEditarParticipacion, setRespuestaEditarParticipacion] = useState({mensajeTexto:"",estado:false});

      
    const updateRespuestaEditarParticipacion=async =>{
        setTimeout(function() {
            setRespuestaEditarParticipacion({mensajeTexto:"",estado:false});
        }, 4000);
    }
  
    const getUsuariosTerapeutasOcupacionales= async() => {
        const respuesta=await obtenerUsuariosTerapeutasOcupacionales(user.Token);
        setUsuariosTo(respuesta)
    }
    const getUsuariosPsicologas= async() => {
        const respuesta=await obtenerUsuariosPsicologas(user.Token);
        setUsuariosSicologas(respuesta)
    }
    const getUsuariosOtros= async() => {
        const respuesta=await obtenerUsuariosOtros(user.Token);
        setUsuariosOtros(respuesta)
            
    }
    const getParticipacionFicha= async() => {
        const respuesta=await obtenerParticipacionGrupalPorId(ParticipacionGrupalId,user.Token);

        setParticipacionFicha(
            {
                Id:respuesta.Id,
                FechaSesion:respuesta.FechaSesion,
                Comentario:respuesta.Comentario,
                ProfesionalOtro:JSON.parse(respuesta.ProfesionalOtro),
                ProfesionalSicologa:JSON.parse(respuesta.ProfesionalSicologa),
                ProfesionalTo:JSON.parse(respuesta.ProfesionalTo),
                NombreSocial:respuesta.NombreSocial,
                Rut:respuesta.Rut
                

            });
    
    }      
    const editParticipacionGrupal=async(ParticipacionFicha)=>{
        if(ParticipacionFicha!=null){
          
            //const d=moment(sesionFicha?.FechaSesion);
            //d.local(true)
            //sesionFicha.FechaSesion=d;
            const respuesta=await editarParticipacionGrupal(ParticipacionFicha,user.Token);
            setRespuestaEditarParticipacion({estado:respuesta.success,mensajeTexto:respuesta.message})
            return respuesta;
        }
    }
    
    useEffect( () => {
        async function setFichaParticipacionFuncion() {
            getParticipacionFicha();
            getUsuariosOtros();
            getUsuariosPsicologas();
            getUsuariosTerapeutasOcupacionales();
        }
        setFichaParticipacionFuncion();
    }, []); 

    return {
      
        participacionFicha,
        setParticipacionFicha,
        getUsuariosTerapeutasOcupacionales,
        getUsuariosPsicologas,
        getUsuariosOtros,
        usuariosTo,
        usuariosSicologas,
        usuariosOtros,
        editParticipacionGrupal,
        respuestaEditarParticipacion,
        updateRespuestaEditarParticipacion,
        getParticipacionFicha
               
       
    }
}
